import Signup from "view3/Signup.js";

import connectFunction from "redux/connectFunction";

function mapStateToProps(state) {
  return {
    categories: state.categories,
    alert: state.alert,
    city: state.city
  };
}

const SignupContainer = connectFunction(mapStateToProps)(Signup);
export default SignupContainer;
